import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "column" }

import Enumeration from "@/components/selectors/enumeration.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {onBeforeMount, PropType, ref} from "vue"
  import {ContactDetails} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'contact_details',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<ContactDetails>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  onBeforeMount(() => {
    read()
  })

  const error = ref<Error>(null)
  const enumerationClient = new EnumerationClient()
  const contactDetailsTypes = ref<string[]>(null)
  const value = _useModel(__props, "value")

  async function read() {
    try {
      const response = await enumerationClient.readContactDetailsEnumerations()
      contactDetailsTypes.value = response.types
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (contactDetailsTypes.value)
              ? (_openBlock(), _createBlock(Enumeration, {
                  key: 0,
                  selection: value.value.type,
                  "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((value.value.type) = $event)),
                  title: "Type",
                  options: contactDetailsTypes.value,
                  readOnly: __props.readOnly
                }, null, 8, ["selection", "options", "readOnly"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_1, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", null, " Name ", -1)),
            _createVNode(TextInput, {
              value: value.value.forename,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value.value.forename) = $event)),
              title: "Forename",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.surnamePrefix,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((value.value.surnamePrefix) = $event)),
              title: "Surname Prefix",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.surname,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((value.value.surname) = $event)),
              title: "Surname",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", null, " Location ", -1)),
            _createVNode(TextInput, {
              value: value.value.address,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((value.value.address) = $event)),
              title: "Address",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.postalCode,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((value.value.postalCode) = $event)),
              title: "Postal Code",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.city,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((value.value.city) = $event)),
              title: "City",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.country,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((value.value.country) = $event)),
              title: "Country",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[14] || (_cache[14] = _createElementVNode("h2", null, " Method ", -1)),
            _createVNode(TextInput, {
              value: value.value.email,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((value.value.email) = $event)),
              title: "Email",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.phone,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((value.value.phone) = $event)),
              title: "Phone",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"]),
            _createVNode(TextInput, {
              value: value.value.website,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((value.value.website) = $event)),
              title: "Website",
              readOnly: __props.readOnly
            }, null, 8, ["value", "readOnly"])
          ]),
          (error.value)
            ? (_openBlock(), _createBlock(ErrorModal, {
                key: 0,
                error: error.value,
                "onUpdate:error": _cache[11] || (_cache[11] = ($event: any) => ((error).value = $event))
              }, null, 8, ["error"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})